import React, { useEffect, useState } from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { FormTextArea, FormInput, FormAutocomplete, SingleAutocompleteGrouping, FormRadio, FormCheckBox, FormAutocompleteGrouping } from "_components/FormElements/FormInput";
import { useForm } from "react-hook-form";
import TextareaAutosize from '@mui/material/TextareaAutosize';
import { Card, CardBody, ListGroupItem, ListGroup, Row, CardHeader,  ModalFooter, ModalHeader, ModalBody,Col } from "reactstrap";

import {
  FormControl,
  InputAdornment,
} from "@material-ui/core";
import {
  Button, Modal
} from "reactstrap";


export const RemoveDelegatesDialog = (props) => {

    const { open, handleClose, handleSave, value } = props;
    //console.log(props)
    const theme = useTheme();
    const { register, handleSubmit, control, errors, watch } = useForm({
      mode: "onBlur",
      // resolver: yupResolver(retailProfileSchema)
    });
    const [reason, setReason] = useState();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));  

   
    const validate = () => {
      handleSave(value);
    }
    
    return (
      <div>
        
        <Modal className="modal-dialog-centered" isOpen={open}>
          <div className="modal-header">
            <strong>Remove Delegates</strong>
            <button aria-label="Close" className="close" data-dismiss="modal" type="button" onClick={handleClose}>
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <div className="modal-body">
           Are you sure want to remove this delegte from this event subscription ?      
          </div>
          <div className="modal-footer">
            <Button color="primary" type="button" onClick={() => validate()} >Remove</Button>
            <Button color="secondary" data-dismiss="modal" type="button" onClick={handleClose}>Cancel</Button>
          </div> 
          <div>
            &nbsp;
          </div>
        </Modal>
      </div>
    );
  }

  export default RemoveDelegatesDialog;